module.exports = __webpack_public_path__ + "img/PEC3000_R.785ba760.png";